/**
 * The streak: days in a row with a mission filed, counted back from today
 * (or yesterday, so a streak is not lost before the day is over). One
 * missed day is forgiven once in the run: a streak that motivates without
 * punishing (Duolingo's freeze, without the shop).
 */
const DAY_MS = 86_400_000;

const dayOf = (t: number) => {
  const d = new Date(t);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
};

export function streakFrom(filedAt: number[], now = Date.now()): number {
  const days = [...new Set(filedAt.map(dayOf))].sort((a, b) => b - a);
  if (!days.length) return 0;
  const today = dayOf(now);
  // the streak must reach today or yesterday
  if (today - days[0] > DAY_MS) return 0;
  let streak = 1;
  let forgiven = false;
  for (let i = 1; i < days.length; i++) {
    const gap = Math.round((days[i - 1] - days[i]) / DAY_MS);
    if (gap === 1) streak++;
    else if (gap === 2 && !forgiven) {
      forgiven = true;
      streak++;
    } else break;
  }
  return streak;
}

/** "Before: Nervous. After: Good." → { before, after }, or null. */
export function feltDelta(howItFelt: string) {
  const m = howItFelt.match(/Before:\s*([A-Za-z]+)\.\s*After:\s*([A-Za-z]+)\./);
  return m ? { before: m[1], after: m[2] } : null;
}
